import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as EmptyStateIcon } from 'applicaiton/assets/empty-state-appointments-past.svg';
import { StyledTr } from './styles';

const EmptyStateByPast: FC = () => {
  const { t } = useTranslation();
  return (
    <StyledTr>
      <td colSpan={5}>
        <div>
          <EmptyStateIcon />
          <h2>{t('patient_profile_empty_state.past.title')}</h2>
          <p>{t('patient_profile_empty_state.past.text')}</p>
        </div>
      </td>
    </StyledTr>
  );
};
export default EmptyStateByPast;
